module.exports = __webpack_public_path__ + "r-2.png?541a816bcf4d32a4cceedc68c32de77b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/r-2.png
// module id = 61
// module chunks = 0